import * as React from 'react';

function SvgIconEdit(props) {
  return (
    <svg viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.803 0a.16.16 0 01.159.16v1.114a.16.16 0 01-.16.16H1.434V14.49H14.49V8.121a.16.16 0 01.16-.16h1.114a.16.16 0 01.16.16v7.166a.636.636 0 01-.637.637H.637A.636.636 0 010 15.287V.637C0 .285.285 0 .637 0zm5.487 0c.042 0 .082.014.114.046l2.474 2.472a.16.16 0 010 .225L7.6 11.003a.165.165 0 01-.108.046l-2.349.058a.32.32 0 01-.326-.323l.038-2.366c0-.042.018-.082.045-.112l8.277-8.26A.165.165 0 0113.29 0zm0 1.732L6.12 8.887l-.014.924.91-.022 7.175-7.16-.9-.897z" />
    </svg>
  );
}

export default SvgIconEdit;
